import { SCENE_INTERACTION } from "../../constants/scene";
import { SOCKET_EVENTS } from "../../socket/Socket";
import { tourID } from "../../socket/SocketTour";
import { SCENE_EVENTS } from "../MVC/Model";
import { WebRTCAdaptor } from "../WebRTC/media-server-external/webrtc_adaptor";
import TourModeWindow from "../engine/TourModeWindow";
import { TRACK_EVENTS } from "../engine/constants/track";
import AudioSocketStreamer from "../STT/AudioSocketStreamer";

export default class TourModeController {
  constructor({ model, socket }) {

    this.connectPromise = null;
    this.connectResolve = null;
    this.connectReject = null;
    model.tourModeController = this;

    this.model = model;
    this.socket = socket;
    this.tourModeView = new TourModeWindow({ model, socket, controller: this })

    this.webRTCAdaptor = null;

    this.dominantSpeakerFinderId = null;
    this.checkSpeakingStreamIds = new Array();

    this.sdpConstraints = {
      OfferToReceiveAudio: false,
      OfferToReceiveVideo: false
    };

    this.mediaConstraints = {
      video: {
        width: { ideal: 640 },
        height: { ideal: 480 },
        frameRate: { ideal: 30, max: 30 }, // Lower frame rate to reduce load
      },
      audio: true
    };

    this.pc_config = {
      'iceServers': [{
        'urls': 'stun:stun1.l.google.com:19302'
      }]
    };

    this.roomNameBox = tourID;

    this.roomOfStream = new Array();
    this.streamsList = new Array();

    this.publishStreamId;
    this.isDataChannelOpen = false;
    this.isMicMuted = false;
    this.isCameraOff = false;
    this.roomTimerId = -1;
    this.onConnectCallback = null;
    this.localStream;
    this.initUsers = false;
    this.introAnimation = false;
    this.tourData = null;
    this.playOnly = false;
    this.pendingPodiumPublish = false;
    this.oldTourData = {};

    this.model.addEventListener(SOCKET_EVENTS.DISCONNECT, () => {
      this.oldTourData = { ...this.model.tourData };
      this.myOldSocketId = this.model.socket.getUserData().socketId;
      this.model.onTourEnded();
      this.leaveRoom();
      this.tourModeView.hide();
    });

    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, (e) => {
      this.leaveRoom();
      this.tourModeView.hide();
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_STOP, (e) => {
      this.tourData = {};
      this.leaveRoom()
      this.tourModeView.hide();
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, async (e) => {
      this.oldTourData = {};
      const { inputValue, componentValue, visibility, id } = e.data;
      this.roomNameBox = `${tourID}-${this.model.config.userId}`;
      if (id) {
        this.tourData = e.data;
      }

      // Cleanup meeting mode streams before starting tour mode
      if (this.model.streamController) {
        try {
          await this.model.streamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up meeting mode streams:", error);
        }
      }

      this.tourModeView.show();
      this.tourModeView.showVideo();
      if (this.webRTCAdaptor) {
        this.turnOnLocalCamera();
        this.joinRoom();
      }
      this.connect()
        .then(() => {
          this.model.socket.onStartGuideMode({ inputValue, componentValue, visibility });
        })
        .catch((error) => {
          this.model.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
        });

    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, async (e) => {
      this.tourData = this.model.tourData[e.data];
      this.roomNameBox = `${tourID}-${this.tourData.id}`;
      this.oldTourData = {};

      // Cleanup meeting mode streams before starting tour mode
      if (this.model.streamController) {
        try {
          await this.model.streamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up meeting mode streams:", error);
        }
      }

      // Join as a tour guest first: websocket in play mode, no camera yet.
      this.playOnly = true;
      this.tourModeView.show();
      this.tourModeView.showVideo();
      if (this.webRTCAdaptor) {
        this.joinRoom();
      }
      this.connect()
        .then(() => {
        })
        .catch((error) => {
        });
    });
    this.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, async (e) => {
      this.initUsers = true;
      this.startTourModeIfExists();
    });
    this.model.addEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, async (e) => {
      this.introAnimation = true;
      this.startTourModeIfExists();
    });
    this.model.addEventListener(SOCKET_EVENTS.RESUME_SESSION, async (e) => {
      this.startTourModeIfExists({ resumeFrozenSession: true });
    });
    this.model.addEventListener(SCENE_EVENTS.ON_TOUR_CONTRIBUTORE_ACCEPTED, async (e) => {
      this.socket.socketTour.acceptTourGuide();
    });
    this.model.addEventListener(SCENE_EVENTS.ON_TOUR_GUEST_ACCEPTED, async () => {
      if (this.roomJoined && this.webRTCAdaptor) {
        this.publishPodiumMedia();
        return;
      }
      // Not in the media room yet. The tour-guest join (TOUR_MODE_STARTED) opens the
      // websocket in play mode; camera and microphone start once that room is joined.
      this.pendingPodiumPublish = true;
      if (this.model.iAmInTour() && !this.connectPromise) {
        this.playOnly = true;
        this.tourModeView.show();
        this.tourModeView.showVideo();
        this.connect().catch(() => {
          this.pendingPodiumPublish = false;
          this.model.alert('error', $trans('error-camera-start'), { dataLang: 'error-camera-start' });
        });
      }
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_ROOM_JOINED, () => {
      if (!this.pendingPodiumPublish) {
        return;
      }
      this.publishPodiumMedia();
    });

    this.model.addEventListener(SCENE_INTERACTION.KILL_GUEST_MODE_SOCKET_REQUEST, async (e) => {
      this.stopPodiumPublish();
    });
    this._onPodium = false;
    this.model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, () => {
      if (this.model.iAmGuide() || this.model.guide) {
        return;
      }
      const tour = this.model.iAmInTour();
      const mySocketId = this.socket.getUserData().socketId;
      const onPodium = !!(tour && Array.isArray(tour.podiumUsers) && tour.podiumUsers.includes(mySocketId));
      if (this._onPodium && tour && !onPodium) {
        this.stopPodiumPublish();
      }
      this._onPodium = onPodium;
    });
  }

  stopPodiumPublish = () => {
    this.publishing = false;
    this.playOnly = true;
    this.pendingPodiumPublish = false;
    if (this.webRTCAdaptor && this.publishStreamId) {
      try {
        this.webRTCAdaptor.stop(this.publishStreamId);
      } catch (error) {
        console.error(error);
      }
    }
    const localVideo = document.getElementById("myTourVideo");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach((track) => track.stop());
      localVideo.srcObject = null;
    }
  }


  connect = () => {
    if (this.connectPromise) {
      return this.connectPromise; // Return the existing Promise if it's already running
    }
    this.connectPromise = new Promise((resolve, reject) => {
      this.connectResolve = resolve;
      this.connectReject = reject;

      const self = this;
      this.ignoredInfoTypes = ["ping", "pong", "roomInformation", "bitrateMeasurement"];
      this.webRTCAdaptor = new WebRTCAdaptor(
        {
          websocket_url: "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket",
          mediaConstraints: this.model.getMediaConstraints(),
          peerconnection_config: this.pc_config,
          sdp_constraints: this.sdpConstraints,
          localVideoId: "myTourVideo",
          isPlayMode: true,
          bandwidth: 500,
          debug: false,
          // dataChannelEnabled: true,
          callback: (info, obj) => {
            !this.ignoredInfoTypes.includes(info) && console.log(info)
            if (info == "initialized") {
              if (this.playOnly) {
                this.isCameraOff = true;
              }
              this.joinRoom();
              this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_CONTROLLER_INITIALIZED })
            }
            else if (info == "joinedTheRoom") {
              this.roomJoined = true;
              this.publishStreamId = obj.streamId
              this.streamsList = obj.streams;
              this.model.publishStreamId = this.publishStreamId;
              const room = obj.ATTR_ROOM_NAME;
              this.roomOfStream[obj.streamId] = room;
              this.onConnectCallback && this.onConnectCallback();
              this.onConnectCallback = null;

              if (this.playOnly) {
                this.isCameraOff = true;
              }

              if (obj.streams != null) {
                obj.streams.forEach(function (item) {
                  self.webRTCAdaptor.play(item, self.token,
                    self.roomNameBox);
                });
              }
              this.roomTimerId = setInterval(() => {
                this.webRTCAdaptor.getRoomInfo(this.roomNameBox, this.publishStreamId);
              }, 3000);

              if (this.model.iAmGuide() || this.model.guide) {
                this.publish();
                this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.TOUR_START, ...this.socket.getUserData() })
              } else {
                this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.TOUR_JOIN, ...this.socket.getUserData() })
              }

              if (this.streamsList.length > 0) {
                this.dominantSpeakerFinderId = setInterval(() => {
                  // this.webRTCAdaptor.getSoundLevelList(this.streamsList);
                }, 200);
              }
              !this.isResolved && (resolve());
              this.isResolved = true;
              this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_ROOM_JOINED })
            }
            else if (info == "newStreamAvailable") {
              if (!this.roomJoined) {
                return
              }
              this.playVideo(obj);
              if (this.dominantSpeakerFinderId == null) {
                this.dominantSpeakerFinderId = setInterval(() => {
                }, 200);
              }
            }
            else if (info == "play_started") {
              this.playVideo(obj);
              if (this.dominantSpeakerFinderId == null) {
                this.dominantSpeakerFinderId = setInterval(() => {
                }, 200);
              }
            }
            else if (info == "publish_started") {
              //stream is being published
              this.onPublishCallback && this.onPublishCallback();
              this.onPublishCallback = null;
              this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_PUBLISH_STARTED });
              ///implement AudioSocketStreamer for the publish stream
              // this.startSTT();

            }
            else if (info == "publish_finished") {
              // this.stopSTT();
            }

            else if (info == "screen_share_stopped") {
              // console.log("screen share stopped");
            }
            else if (info == "gotSoundList") {
              this.findDominantSpeaker(obj);
            }
            else if (info == "trackList") {
              // console.log(info, obj)
            }
            else if (info == "browser_screen_share_supported") {
            }
            else if (info == "leavedFromRoom") {
              const room = obj.ATTR_ROOM_NAME;
              this.dominantSpeakerFinderId && clearInterval(this.dominantSpeakerFinderId);
              this.roomTimerId && clearInterval(this.roomTimerId);
              this.dominantSpeakerFinderId = null;

              if (this.model.iAmGuide()) {
                this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.END_TOUR, ...this.socket.getUserData() })
              } else {
                this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.END_TOUR, ...this.socket.getUserData() })
              }

              // Ensure all remote video tracks are stopped
              if (this.streamsList != null) {
                this.streamsList.forEach(function (item) {
                  self.removeRemoteVideo(item);
                });
              }

              // Stop local video tracks explicitly
              const localVideo = document.getElementById("myTourVideo");
              if (localVideo && localVideo.srcObject) {
                localVideo.srcObject.getTracks().forEach(track => {
                  track.stop();
                  track.enabled = false;
                });
                localVideo.srcObject = null;
              }

              // Stop guide video tracks if exists
              const guideVideo = document.getElementById("myTourVideoGuide");
              if (guideVideo && guideVideo.srcObject) {
                guideVideo.srcObject.getTracks().forEach(track => {
                  track.stop();
                  track.enabled = false;
                });
                guideVideo.srcObject = null;
              }

              // we need to reset streams list
              this.streamsList = new Array();
              this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_ROOM_LEFT })
            }
            else if (info == "closed") {
              //// console.log("Connection closed");
              if (typeof obj != "undefined") {
                reject(new Error("Connection closed"));
              } else if (info === "error") {
                reject(new Error(obj)); // Change to a more specific error message if available
              }
            }
            else if (info == "play_finished") {
              this.removeRemoteVideo(obj.streamId);
            }
            else if (info == "streamInformation") {
              this.streamInformation(obj);
            }
            else if (info == "roomInformation") {
              //Checks if any new stream has added, if yes, plays.
              for (let str of obj.streams) {
                if (!this.streamsList.includes(str)) {
                  this.webRTCAdaptor.play(str, this.token,
                    this.roomNameBox);
                }
              }
              // Checks if any stream has been removed, if yes, removes the view and stops webrtc connection.
              for (let str of this.streamsList) {
                if (!obj.streams.includes(str)) {
                  this.removeRemoteVideo(str);
                }
              }
              //Lastly updates the current streamlist with the fetched one.
              this.streamsList = obj.streams;

              //Check video tracks active/inactive status
              this.checkVideoTrackStatus(this.streamsList);
            }
            else if (info == "data_channel_opened") {
              console.log("Data Channel open for stream id", obj);
              this.isDataChannelOpen = true;
            }
            else if (info == "data_channel_closed") {
              this.isDataChannelOpen = false;
            }
            else if (info == "data_received") {
              // this.handleNotificationEvent(obj);
            }
            else if (info == "speaking_but_muted") {
              //show speaking_but_muted
            }
            else if (info == "session_restored") {

            }
          },
          callbackError: function (error, message) {
            //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
            if (error === "NotAllowedError") {
              self.model.showSelfCheckModal();
            }
            if (error === "PermissionDeniedError") {
              self.model.showSelfCheckModal();
            }
            if (error.indexOf("publishTimeoutError") != -1 && self.roomTimerId != null) {
              clearInterval(self.roomTimerId);
            }
            let errorMessage = JSON.stringify(error);
            if (typeof message != "undefined") {
              errorMessage = message;
            }
            errorMessage = JSON.stringify(error);
            if (error.indexOf("NotFoundError") != -1) {
              errorMessage = "Camera or Mic are not found or not allowed in your device.";
            } else if (error.indexOf("NotReadableError") != -1
              || error.indexOf("TrackStartError") != -1) {
              errorMessage = "Camera or Mic is being used by some other process that does not not allow these devices to be read.";
            } else if (error.indexOf("OverconstrainedError") != -1
              || error.indexOf("ConstraintNotSatisfiedError") != -1) {
              errorMessage = "There is no device found that fits your video and audio constraints. You may change video and audio constraints."
            } else if (error.indexOf("TypeError") != -1) {
              errorMessage = "Video/Audio is required.";
            } else if (error.indexOf("UnsecureContext") != -1) {
              errorMessage = "Fatal Error: Browser cannot access camera and mic because of unsecure context. Please install SSL and access via https";
            } else if (error.indexOf("WebSocketNotSupported") != -1) {
              errorMessage = "Fatal Error: WebSocket not supported in this browser";
            } else if (error.indexOf("no_stream_exist") != -1) {
              //TODO: removeRemoteVideo(error.streamId);
            } else if (error.indexOf("data_channel_error") != -1) {
              errorMessage = "There was a error during data channel communication";
            } else if (error.indexOf("ScreenSharePermissionDenied") != -1) {
              errorMessage = "You are not allowed to access screen share";
              // this.screen_share_checkbox.checked = false;
              // this.camera_checkbox.checked = true;
            }
            // console.log(`%c${errorMessage}`, 'color: red');
            // alert(errorMessage);
          }
        });

      this.webRTCAdaptor.onerror = function (err) {
        reject(err);
      };
    });

    return this.connectPromise;
  }

  checkVideoTrackStatus = (streamsList) => {
    streamsList.forEach((item) => {
      if (item === this.model.tourStreamController.screenController.publishStreamId)
        return;
      if (item === this.model.tourStreamController.cameraController.publishStreamId)
        return;
      const video = document.getElementById("tourRemoteVideo-" + item);
      if (video != null && video.srcObject && !video.srcObject.active) {
        this.self.stop(item);
        // this.controller.removeRemoteVideo(item);
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
      if (video === null) {
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
    });
  }
  removeRemoteVideo = (streamId) => {
    if (this.model.isMineTourStream(streamId)) {
      return;
    }
    const video = document.getElementById("tourRemoteVideo-" + streamId);
    if (video != null) {
      var player = document.getElementById("player-" + streamId);
      video.srcObject && video.srcObject.getTracks().forEach(track => track.stop());
      video.srcObject = null;
      $(player).remove();
    }
    this.webRTCAdaptor.stop(streamId);
    this.streamsList = this.streamsList.filter(item => item !== streamId);
    this.model.dispatchEvent({ type: SCENE_INTERACTION.STREAM_REMOVED, data: { streamId } })
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted) {
      return
    }
  }
  createRemoteVideo = (streamId, stream) => {
    return new Promise((resolve, reject) => {
      const player = document.createElement("div");
      player.id = "player-" + streamId;
      player.innerHTML = '<video id="tourRemoteVideo-' + streamId + '" autoplay playsinline></video>';
      const videoElement = player.childNodes[0];
      document.getElementById("players").appendChild(player);
      videoElement.srcObject = stream;
      // Ensure the video is ready to play through
      videoElement.addEventListener('loadeddata', () => {
        videoElement.play().then(() => {
          videoElement.setAttribute('canplaythrough', 'true');
          resolve(videoElement);
        }).catch(e => {
          console.error('Error in playing video:', e);
          reject(e);
        });
      });

      // Error handling
      videoElement.addEventListener('error', (e) => {
        console.error('Error in video playback:', e);
        reject(e);
      });
    });
  }

  playVideo = (obj) => {
    if (this.model.isMineTourStream(obj.streamId)) {
      return;
    }
    this.webRTCAdaptor.getStreamInfo(obj.streamId);
    obj.stream && this.webRTCAdaptor.enableAudioLevel(obj.stream, obj.streamId)
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted) {
      return
    }
    if (obj.streamId.includes("GUIDE")) {
      if (!$("#myTourVideoGuide")[0].srcObject || !$("#myTourVideoGuide")[0].srcObject.active) {
        $("#myTourVideoGuide")[0].srcObject = obj.stream;
        this.model.dispatchEvent({ type: SCENE_INTERACTION.STREAM_GUIDE_RECIEVED, data: obj })

      }
    }
    else {
      let video = document.getElementById("tourRemoteVideo-" + obj.streamId);
      if (video == null) {
        this.createRemoteVideo(obj.streamId, obj.stream).then(videoElement => {
          if (!obj.streamId.includes("TOUR-SCREEN-SHARE")) {
            this.model.dispatchEvent({ type: SCENE_INTERACTION.STREAM_RECIEVED, data: obj })

          } else {
            this.model.dispatchEvent({ type: SCENE_INTERACTION.SCREEN_SHARE_STREAM_RECIEVED, data: obj })
          }
        });
      }
    }
  }
  publishPodiumMedia = () => {
    if (!this.webRTCAdaptor || !this.roomJoined) {
      this.pendingPodiumPublish = true;
      return;
    }
    this.pendingPodiumPublish = false;
    this.playOnly = false;
    // play-only join marks the camera off. Force the toggles so they actually open the devices.
    this.isCameraOff = true;
    this.isMicMuted = true;
    this.publish();
    this.turnOnLocalCamera();
    this.unmuteLocalMic();
    if (this.publishStreamId) {
      this.socket.socketTour.acceptAsTourGuest(this.publishStreamId);
      this.socket.acceptTourGuestMode(this.publishStreamId);
    }
  }
  publish = (streamName, token) => {
    this.publishing = true;
    this.webRTCAdaptor.publish(this.publishStreamId, token);
    this.unmuteLocalMic();

    const videoTrack = $("#myTourVideo");
    const data = {
      publishStreamId: this.publishStreamId
    };
    if (!videoTrack[0].srcObject) {
      videoTrack[0].addEventListener('loadeddata', () => {
        this.model.dispatchEvent({ type: SCENE_INTERACTION.TOUR_MODE_STARTED_PUBLISHING, data })
        const videoTrack = $("#myTourVideo");
        videoTrack[0].srcObject.getVideoTracks()[0].addEventListener('ended', () => {
          this.model.tourOnScreenShareSeatStandUp();
        });
      });
    } else {
      this.model.dispatchEvent({ type: SCENE_INTERACTION.TOUR_MODE_STARTED_PUBLISHING, data })
      videoTrack[0].srcObject.getVideoTracks()[0].addEventListener('ended', () => {
      });
    }
  }
  unPublish = (s) => {
    this.publishing = false;
    if (this.publishStreamId && this.webRTCAdaptor) {
      this.webRTCAdaptor.stop(this.publishStreamId);
    }
  }

  streamInformation = (obj) => {
    this.webRTCAdaptor.play(obj.streamId, this.token, this.roomNameBox);
  }
  joinRoom = () => {
    this.roomJoined = true;
    this.publishStreamId = "CAMERA-TOUR" + this.model.config.userId;
    if (this.model.iAmGuide() || this.model.guide) {
      this.publishStreamId = "CAMERA-GUIDE" + this.model.config.userId;
    }
    this.webRTCAdaptor.joinRoom(this.roomNameBox, this.publishStreamId);
  }


  switchVideo = (deviceId) => {
    if (!this.publishStreamId || !this.webRTCAdaptor || !this.publishing) {
      return
    }
    this.webRTCAdaptor.switchVideoCameraCapture(this.publishStreamId, deviceId)
  }
  switchAudio = (deviceId) => {
    this.audioId = deviceId;
    if (!this.publishStreamId || !this.webRTCAdaptor || !this.publishing) {
      return
    }
    this.webRTCAdaptor.switchAudioInputSource(this.publishStreamId, deviceId)
  }

  leaveRoom = () => {
    this.roomJoined = false;
    this.publishing = false;
    this.pendingPodiumPublish = false;
    this.onConnectCallback = null;

    // Stop all remote video tracks before leaving
    if (this.streamsList && this.streamsList.length > 0) {
      this.streamsList.forEach((streamId) => {
        const video = document.getElementById("tourRemoteVideo-" + streamId);
        if (video && video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
          video.srcObject = null;
        }
        this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
      });
      this.streamsList = [];
    }

    // Stop local video tracks
    const localVideo = document.getElementById("myTourVideo");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }

    // Stop guide video tracks if exists
    const guideVideo = document.getElementById("myTourVideoGuide");
    if (guideVideo && guideVideo.srcObject) {
      guideVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      guideVideo.srcObject = null;
    }

    if (this.webRTCAdaptor) {
      this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
      this.webRTCAdaptor.closeStream();
    }
    $('[id^="tourRemoteVideo-"]').remove();
  }

  /**
   * Cleanup all tour mode streams and wait for cleanup to complete
   * Returns a Promise that resolves when all streams are closed
   * This should be called before switching to meeting mode
   */
  cleanupStreams() {
    return new Promise((resolve) => {
      // If no adaptor exists, resolve immediately
      if (!this.webRTCAdaptor) {
        resolve();
        return;
      }

      // Stop all remote video tracks
      if (this.streamsList && this.streamsList.length > 0) {
        this.streamsList.forEach((streamId) => {
          const video = document.getElementById("tourRemoteVideo-" + streamId);
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => {
              track.stop();
              track.enabled = false;
            });
            video.srcObject = null;
          }
          this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
        });
        this.streamsList = [];
      }

      // Stop local video tracks
      const localVideo = document.getElementById("myTourVideo");
      if (localVideo && localVideo.srcObject) {
        localVideo.srcObject.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        localVideo.srcObject = null;
      }

      // Stop guide video tracks if exists
      const guideVideo = document.getElementById("myTourVideoGuide");
      if (guideVideo && guideVideo.srcObject) {
        guideVideo.srcObject.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        guideVideo.srcObject = null;
      }

      // Leave room and close stream
      if (this.webRTCAdaptor) {
        this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
        this.webRTCAdaptor.closeStream();

        // Wait a bit for cleanup to complete, then resolve
        setTimeout(() => {
          this.roomJoined = false;
          this.publishing = false;
          resolve();
        }, 300);
      } else {
        resolve();
      }
    });
  }

  liveAudioTracks() {
    const tracks = [];
    const localStream = this.webRTCAdaptor?.mediaManager?.localStream;
    if (localStream) {
      tracks.push(...localStream.getAudioTracks());
    }
    const peer = this.publishStreamId && this.webRTCAdaptor?.remotePeerConnection?.[this.publishStreamId];
    if (peer) {
      peer.getSenders().forEach((sender) => {
        if (sender.track && sender.track.kind === 'audio' && !tracks.includes(sender.track)) {
          tracks.push(sender.track);
        }
      });
    }
    return tracks.filter((track) => track.readyState === 'live');
  }

  applyMicEnabled(enabled) {
    const tracks = this.liveAudioTracks();
    tracks.forEach((track) => {
      track.enabled = enabled;
    });
    return tracks.length > 0;
  }

  reopenMicrophone() {
    const manager = this.webRTCAdaptor?.mediaManager;
    if (!manager || !this.publishing || !this.publishStreamId) {
      return;
    }
    const selected = this.audioId || this.model.view?.deviceSettingsMenu?.selected?.microphone?.value;
    const audio = !selected || selected === 'default'
      ? true
      : {
        deviceId: { exact: selected },
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      };
    const generation = (this._micReopenGeneration || 0) + 1;
    this._micReopenGeneration = generation;
    manager.navigatorUserMedia({ audio, video: false }, (stream) => {
      if (this._micReopenGeneration !== generation || !this.publishing || !this.publishStreamId) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }
      manager.updateAudioTrack(stream, this.publishStreamId, null);
      if (this.isMicMuted) {
        this.applyMicEnabled(false);
      }
    }, true);
  }

  muteLocalMic() {
    if (!this.webRTCAdaptor)
      return;
    this._micReopenGeneration = (this._micReopenGeneration || 0) + 1;
    if (this.isMicMuted) {
      this.applyMicEnabled(false);
      this.tourModeView?.setMicrophoneMuted(true);
      return;
    }
    this.isMicMuted = true;
    this.webRTCAdaptor.muteLocalMic();
    this.applyMicEnabled(false);
    this.socket.updateUserData({ 'userAudioMuted': true });
    this.tourModeView?.setMicrophoneMuted(true);
  }

  unmuteLocalMic() {
    if (!this.webRTCAdaptor)
      return;
    if (!this.isMicMuted) {
      this.tourModeView?.setMicrophoneMuted(false);
      return;
    }
    this.isMicMuted = false;
    const hasLiveTrack = this.applyMicEnabled(true);
    this.webRTCAdaptor.unmuteLocalMic();
    // A previous capture can end the published track. Reopen only when a stream
    // already exists; a stream that is still starting will arrive unmuted.
    if (!hasLiveTrack && this.webRTCAdaptor.mediaManager?.localStream) {
      this.reopenMicrophone();
    }
    this.socket.updateUserData({ 'userAudioMuted': false });
    this.tourModeView?.setMicrophoneMuted(false);
  }
  turnOffLocalCamera() {
    if (this.isCameraOff)
      return;
    this.isCameraOff = true;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.turnOffLocalCamera(this.publishStreamId);
    this.socket.updateUserData({ 'userVideoMuted': true });
  }

  turnOnLocalCamera() {
    if (!this.isCameraOff)
      return;
    this.isCameraOff = false;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.turnOnLocalCamera(this.publishStreamId);
    this.socket.updateUserData({ 'userVideoMuted': false });
  }

  switchLocalVideo(videoElement) {
    videoElement.srcObject = this.webRTCAdaptor.mediaManager.localStream;
    this.webRTCAdaptor.mediaManager.localVideo = videoElement;
  }
  switchLocalStream(mediaStream) {
    this.webRTCAdaptor.mediaManager.localStream = mediaStream;
  }

  muteOtherMic(user) {
    this.socket.requestUpdateUserData(
      user.userId,
      { 'userAudioMuted': true }
    )
  }

  unmuteOtherMic(user) {
    this.socket.requestUpdateUserData(
      user.userId,
      { 'userAudioMuted': false }
    )
  }

  turnOffOtherCamera(user) {
    this.socket.requestUpdateUserData(
      user.userId,
      { 'userVideoMuted': true }
    )
  }

  turnOnOtherCamera(user) {
    this.socket.requestUpdateUserData(
      user.userId,
      { 'userVideoMuted': false }
    )
  }

  startTourModeIfExists({ resumeFrozenSession = false } = {}) {
    if (!this.initUsers || !this.introAnimation || (!resumeFrozenSession && this.model.isFrozenSession)) {
      return;
    }
    const tourStarted = this.model.iWasInTour(this.oldTourData, this.myOldSocketId);
    if (!tourStarted) {
      return
    }
    // this.tourModeView.showAvatar(guide.userAvatarUrl);
    this.model.view.tourBanner.show();
    const callback = () => {
      if (this.socket.getUserData().currentSceneId !== guide.currentSceneId) {
        this.model.nextSceneId = guide.currentSceneId;
        this.socket.acceptGuideMode(guide.tourName);
        this.model.dispatchEvent({
          type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
            sceneId: guide.currentSceneId
          }
        });
      }
      if (this.model.tourWithIdFromInvite) {
        this.connect()
          .then(() => {
            const tour = this.model.tourData[this.model.tourData[this.model.tourWithIdFromInvite]];
            if (tour && !this.model.refuseOneToOneJoin(tour)) {
              this.model.onTourStarted(tour.id);
              this.model.socket.enableGuidedCamera();
              this.model.socket.acceptGuideMode(tour);
            }
          })
          .catch((error) => {
          });
      }
    }
    if (this.model.startTourWithIdFromInvite) {
      callback();
    }
    if (tourStarted && !this.model.refuseOneToOneJoin(tourStarted)) {
      this.connect()
        .then(() => {
          this.model.onTourStarted(tourStarted.id);
          this.socket.acceptGuideMode(tourStarted);
          this.playOnly = true;
          this.tourModeView.show();
          this.tourModeView.showVideo();
        })
        .catch((error) => {
        });
    }
  }
  findDominantSpeaker(streamSoundList) {
    let tmpMax = 0;
    let tmpStreamId = null;
    let threshold = 0.01;

    for (let i = 0; i < this.streamsList.length; i++) {
      let nextStreamId = this.streamsList[i];
      let tmpValue = streamSoundList[nextStreamId]
      if (tmpValue > threshold) {
        if (tmpValue > tmpMax) {
          tmpMax = tmpValue;
          tmpStreamId = nextStreamId;
        }
      }
    }
    if (tmpStreamId != null) {
      if (this.checkSpeakingStreamIds[tmpStreamId] == null || typeof this.checkSpeakingStreamIds[tmpStreamId] == "undefined") {
        this.checkSpeakingStreamIds[tmpStreamId] = true;
        this.tourModeView.setDominantSpeaker(tmpStreamId);
        setTimeout(() => {
          this.checkSpeakingStreamIds[tmpStreamId] = null;
          this.tourModeView.removeDominantSpeaker(tmpStreamId);
        }, 1000)
      }
    }
  }
  async startSTT() {
    const socketIO = this.socket; // raw socket.io client
    const mediaStream = this.webRTCAdaptor?.mediaManager?.localStream;
    this.sttStreamer = new AudioSocketStreamer({
      mediaStream,
      socket: socketIO,
      options: {
        socketType: 'socketio',
        sendEventName: 'stt-audio',      // server listens here
        resultEventName: 'stt-result',   // server emits back here
        targetSampleRate: 16000,
        transport: 'binary',             // send ArrayBuffer PCM16
        sendIntervalMs: 250,             // batch every 250ms (0 = send every callback)
        metadata: { language: 'en' }, // optional (ISO-639-1)
        onResult: (payload) => {
          console.log('STT result:', payload);
        },
        onError: (err) => console.error('STT error:', err),
        onDebug: (debug) => console.log('STT debug:', debug),
      },
    });
  }
  stopSTT() {
    this.sttStreamer?.stop();
    this.sttStreamer?.destroy();
    this.sttStreamer = null;
  }
}
